<template>
  <div class="sidebar-inner">
      <!-- Suggestion Details Modal -->
  <b-modal id="suggestion-details-modal" title="Booking Details" hide-footer size="lg">
    <div v-if="selectedSuggestion" class="suggestion-details">
      <b-tabs content-class="mt-3">
        <b-tab title="Booking" active>
          <div class="property-card">
            <table class="table table-striped table-centered mb-0">
              <tbody>
                <tr>
                  <th width="30%">Booking ID</th>
                  <td>{{ selectedSuggestion.BookingId }}</td>
                </tr>
                <tr>
                  <th>Booking Title</th>
                  <td>{{ selectedSuggestion.BookingTitle }}</td>
                </tr>
                <tr>
                  <th>Group ID</th>
                  <td>{{ selectedSuggestion.GroupId || '-' }}</td>
                </tr>
                <tr>
                  <th>Departure Date</th>
                  <td>{{ formatDate(selectedSuggestion.DepartureDate) }}</td>
                </tr>
                <tr>
                  <th>Return Date</th>
                  <td>{{ formatDate(selectedSuggestion.ReturnDate) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-tab>

        <b-tab title="Client">
          <div class="property-card">
            <table class="table table-striped table-centered mb-0">
              <tbody>
                <tr>
                  <th width="30%">Client Name</th>
                  <td>{{ selectedSuggestion.ClientName }}</td>
                </tr>
                <tr>
                  <th>Client Email</th>
                  <td>{{ selectedSuggestion.ClientEmail || '-' }}</td>
                </tr>
                <tr>
                  <th>Client ID</th>
                  <td>{{ selectedSuggestion.ClientId }}</td>
                </tr>
                <tr>
                  <th>Lead Name</th>
                  <td>{{ selectedSuggestion.LeadName }}</td>
                </tr>
                <tr>
                  <th>Lead Email</th>
                  <td>{{ selectedSuggestion.LeadEmail || '-' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-tab>

        <b-tab title="Caller">
          <div class="property-card">
            <table class="table table-striped table-centered mb-0">
              <tbody>
                <tr>
                  <th width="30%">Caller Name</th>
                  <td>{{ selectedSuggestion.CallerName }}</td>
                </tr>
                <tr>
                  <th>Caller Email</th>
                  <td>{{ selectedSuggestion.CallerEmail || '-' }}</td>
                </tr>
                <tr>
                  <th>Caller Phone</th>
                  <td>{{ selectedSuggestion.CallerPhoneNo || '-' }}</td>
                </tr>
                <tr>
                  <th>Caller Client ID</th>
                  <td>{{ selectedSuggestion.CallerClientId || '-' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-tab>
      </b-tabs>

      <div class="text-right mt-3">
        <button 
          class="btn btn-itg"
          @click="applySuggestion(selectedSuggestion.BookingId)"
          :disabled="isSaving"
        >
          <i v-if="isSaving" class="fas fa-spinner fa-spin mr-1"></i>
          Apply This Booking
        </button>
      </div>
    </div>
  </b-modal>

    <!-- Top section -->
    <div class="top-section">
      <div v-if="!isLoadingAxumData">
        <div class="d-flex">
          <div class="flex-grow-1">
            <h4 class="mb-1">AXUM</h4>
          </div>
          <div class="flex-shrink-1" v-if="ticket.axum_booking_id">
            <span class="badge font-size-14 badge-primary" v-if="isFIT"
              >FIT</span
            >
            <span class="badge font-size-14 badge-primary" v-if="isSGT"
              >SGT</span
            >
          </div>
        </div>
      </div>
      <h4 v-if="isLoadingAxumData" class="mb-1">Loading AXUM Data...</h4>
      <hr />
      <!-- Is Loading -->
      <div class="text-center mt-4" v-if="isLoadingAxumData">
        <b-spinner class="m-2" variant="itg-dark" role="status"></b-spinner>
      </div>
      <!-- / Is Loading -->

      <!-- Loaded -->
      <div v-if="!isLoadingAxumData && axumData !== null && !axumData.suggestions">
        <div class="property-card">
          <b class="property-name">AXUM Booking ID</b>
          <div class="mt-1">
            {{
              ticket.axum_booking_id ? ticket.axum_booking_id : "Not Provided"
            }}
          </div>
        </div>

        <div class="property-card mt-3">
          <b class="property-name"> Booking Title </b>
          <div class="mt-1">
            <span v-if="axumData.bookingTitle">
              {{ axumData.bookingTitle }}
            </span>
            <span v-else>-</span>
          </div>
        </div>

        <div class="property-card mt-3">
          <b class="property-name"> Consultant </b>
          <div class="mt-1">
            <span v-if="axumData.consultant">
              {{ axumData.consultant.username }}
            </span>
            <span v-else>-</span>
          </div>
        </div>

        <div class="property-card mt-3">
          <b class="property-name"> Consultant Branch </b>
          <div class="mt-1">
            <span
              v-if="
                axumData.consultant &&
                axumData.consultant.branch &&
                axumData.consultant.branch.formalName
              "
            >
              {{ axumData.consultant.branch.formalName }}
            </span>
            <span v-else>-</span>
          </div>
        </div>

        <div class="property-card mt-3">
          <b class="property-name"> Travel Agent </b>
          <div class="mt-1">
            <span v-if="axumData.ownerName">
              {{ axumData.ownerName }}
            </span>
            <span v-else>-</span>
          </div>
        </div>

        <div class="property-card mt-3">
          <b class="property-name"> Admin </b>
          <div class="mt-1">
            <div v-if="axumData.admin">
              {{ axumData.admin.username }}
              <span v-if="axumData.admin.jobTitle"
                >({{ axumData.admin.jobTitle }})</span
              >
            </div>
            <span v-else>-</span>
          </div>
        </div>

        <div class="property-card mt-3">
          <b class="property-name"> Departure Date </b>
          <div class="mt-1">
            <span v-if="axumData.departureDate">
              {{ formatDate(axumData.departureDate) }}
            </span>
            <span v-else>-</span>
          </div>
        </div>

        <div class="property-card mt-3">
          <b class="property-name"> Return Date </b>
          <div class="mt-1">
            <span v-if="axumData.returnDate">
              {{ formatDate(axumData.returnDate) }}
            </span>
            <span v-else>-</span>
          </div>
        </div>

        <div class="property-card mt-3">
          <b class="property-name"> Lead Pax </b>
          <div class="mt-1">
            <span v-if="leadPax">
              {{ leadPax.firstname }} {{ leadPax.surname }}
            </span>
            <span v-else>-</span>
          </div>
        </div>

        <pax-affected class="mt-3"></pax-affected>

        <div class="axum-data mt-3" v-if="axumData.length == 0">
          <div class="property-card">
            <b class="property-name text-danger">
              No data for this Booking ID
            </b>
          </div>
        </div>
      </div>

      <div v-if="!isLoadingAxumData && (!axumData || axumData && axumData.suggestions !== undefined)">
        <div class="property-card">
          <b class="property-name text-danger"> No AXUM booking linked.</b>
          <!-- <div v-if="(suggestions && suggestions.length) || (suggestions && suggestions.length == 0)" class="mt-1 suggestion-text"> -->
          <div class="mt-1 suggestion-text">
            Based on the primary contact, we think the following bookings might be relevant:
          </div>
        </div>

        <!-- No suggestions -->
        <div v-if="!suggestions || suggestions.length == 0" class="property-card mt-3">
          <b class="property-name text-danger">No suggestions found</b>
        </div>

        <!-- Suggestions -->
        <div v-if="suggestions && suggestions.length" class="mb-3">
          <div v-for="(suggestion, i) in suggestions" :key="`suggestion-${i}`" class="property-card mt-3">
            <b class="property-name">Suggestion {{ i + 1 }}</b>
            <div class="mt-2 suggestion-text">
              <div class="mb-2">
                <span>Booking ID</span> <br>
                {{ suggestion.BookingId }}
              </div>
              <div class="mb-2">
                <span>Booking Title</span> <br>
                {{ suggestion.BookingTitle }}
              </div>
              <div class="mb-2">
                <span>Client</span> <br>
                {{ suggestion.ClientName }}
              </div>
              <div class="mb-2">
                <span>Travel Dates</span> <br>
                {{ formatDate(suggestion.DepartureDate) }} - {{ formatDate(suggestion.ReturnDate) }}
              </div>
              <div class="mt-3">
                <button 
                  class="btn btn-sm btn-itg w-100 mb-2"
                  @click="applySuggestion(suggestion.BookingId)"
                  :disabled="isSaving"
                >
                  <i v-if="isSaving" class="fas fa-spinner fa-spin mr-1"></i>
                  Apply Suggestion
                </button>
                <button 
                  class="btn btn-sm btn-itg-dark w-100"
                  @click="viewSuggestionDetails(suggestion)"
                >
                  View More
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- / Suggestions -->
      </div>
      <!-- / Loaded -->
    </div>
    <!-- / Top section -->
    <!-- Bottom section -->
    <div class="bottom-section pt-3 pb-3" v-if="!isLoadingAxumData && axumData && !axumData.suggestions">
      <itinerary-button-and-modal></itinerary-button-and-modal>

      <!--            <a href="#" @click.prevent="refresh" class="btn btn-itg-dark btn-block"-->
      <!--               :class="{'disabled': isLoadingAxumData}">-->
      <!--                <i class="fa fa-sync mr-1"></i>-->
      <!--                Refresh-->
      <!--            </a>-->
    </div>
    <!-- / Bottom section -->
  </div>
</template>

<script>
import Forms from "../../../../../mixins/Forms";
import Tickets from "../../../../../mixins/Tickets";
import Dates from "../../../../../mixins/Dates";
import PaxAffected from "./Axum/PaxAffected";
import ItineraryButtonAndModal from "./Axum/ItineraryButtonAndModal";
import { mapGetters, mapActions } from "vuex";
import axios from "axios";
import _ from "lodash";

export default {
  name: "AxumSidebar",
  mixins: [Forms, Tickets, Dates],
  data() {
    return {
      isSaving: false,
      selectedSuggestion: null
    };
  },
  created() {
    this.loadAxumData();
  },
  components: { PaxAffected, ItineraryButtonAndModal },
  computed: {
    ...mapGetters("ticketViewer", {
      ticket: "ticket",
      isLoadingAxumData: "isLoadingAxumData",
      axumData: "axumData",
    }),

    isFIT() {
      if (this.ticket.axum_booking_id && !isNaN(this.ticket.axum_booking_id)) {
        return Number(this.ticket.axum_booking_id) < 2000000;
      }
      return false;
    },

    isSGT() {
      if (this.ticket.axum_booking_id && !isNaN(this.ticket.axum_booking_id)) {
        return Number(this.ticket.axum_booking_id) >= 2000000;
      }
      return false;
    },

    leadPax() {
      if (this.axumData.leadPassengerId) {
        return _.first(this.axumData.passengers, {
          passengerId: this.axumData.leadPassengerId,
        });
      }
      return null;
    },

    suggestions() {
      // return [
      //   {
      //     "BookingId": "1226923",
      //     "GroupId": "0",
      //     "BookingTitle": "Al's trip to Australia and Japan",
      //     "DepartureDate": "2025-01-17T00:00:00.000Z",
      //     "ReturnDate": "2025-02-06T00:00:00.000Z",
      //     "ClientId": "1021467",
      //     "ClientType": "1",
      //     "ClientName": "Mr A Donnelly",
      //     "ClientEmail": "alastair@insideasiatours.com",
      //     "LeadName": "Mr A Donnelly",
      //     "LeadEmail": "",
      //     "CallerClientId": "1021467",
      //     "CallerPhoneNo": "07900812751",
      //     "CallerName": "Mr A Donnelly",
      //     "CallerEmail": "alastair@insideasiatours.com"
      //   },
      //   {
      //     "BookingId": "1226923",
      //     "GroupId": "0",
      //     "BookingTitle": "Al's trip to Australia and Japan",
      //     "DepartureDate": "2025-01-17T00:00:00.000Z",
      //     "ReturnDate": "2025-02-06T00:00:00.000Z",
      //     "ClientId": "1021467",
      //     "ClientType": "1",
      //     "ClientName": "Mr A Donnelly",
      //     "ClientEmail": "alastair@insideasiatours.com",
      //     "LeadName": "Mr A Donnelly",
      //     "LeadEmail": "",
      //     "CallerClientId": "1021467",
      //     "CallerPhoneNo": "07900812751",
      //     "CallerName": "Mr A Donnelly",
      //     "CallerEmail": "alastair@insideasiatours.com"
      //   }
      // ];
      if (!this.isLoadingAxumData && this.axumData && this.axumData.suggestions) {
        return _.uniqBy(this.axumData.suggestions, 'BookingId');
      }
      return [];
    },
  },
  methods: {
    ...mapActions("ticketViewer", {
      loadAxumData: "loadAxumData",
      reloadTicket: "reloadTicket"
    }),

    refresh() {
      if (this.isLoadingAxumData) {
        return false;
      }
      this.loadAxumData();
    },

    applySuggestion(bookingId) {
      let vm = this;
      swal({
        title: "Apply Suggestion",
        text: `Are you sure you want to set the Axum Booking ID to ${bookingId}?`,
        icon: "info",
        buttons: {
          cancel: true,
          confirm: "Apply"
        },
        // dangerMode: true
      }).then((shouldApply) => {
        if (shouldApply) {
          vm.isSaving = true;
          axios.put(API_BASE + '/tickets/' + vm.ticket.id, {
            axum_booking_id: bookingId
          }).then(r => {
            vm.isSaving = false;
            vm.$notify.success({
              title: 'Success!',
              message: 'Booking ID updated successfully'
            });
            vm.$bvModal.hide('suggestion-details-modal');
            vm.reloadTicket(); // This will refresh the entire ticket data
          }).catch(e => {
            vm.isSaving = false;
            vm.setErrors(e);
          });
        }
      });
    },

    viewSuggestionDetails(suggestion) {
      this.selectedSuggestion = suggestion;
      this.$bvModal.show('suggestion-details-modal');
    }
  },
};
</script>

<style scoped lang="scss">
.property-card {
  background: #fff;
  border-radius: 5px;
  padding: 15px;

  .property-name {
    font-weight: 600;
    color: #2c5cc5;
  }

  .row {
    margin-left: -10px;
    margin-right: -10px;
    
    > div {
      padding-left: 10px;
      padding-right: 10px;
    }
  }
}

.suggestion-text {
  font-size: 12px;
  line-height: 19px;
}

.suggestion-text span {
  font-weight: 500;
}

.suggestion-details {
  span {
    font-weight: 500;
    color: #2c5cc5;
    font-size: 12px;
  }
}
</style>
